module.exports = __webpack_public_path__ + "img/icon-close.bcc880af.svg";